/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageRead } from '../../models/message-read';

export interface GetMessagesApiV1MessageSessionSessionIdGet$Params {
  session_id: string;
}

export function getMessagesApiV1MessageSessionSessionIdGet(http: HttpClient, rootUrl: string, params: GetMessagesApiV1MessageSessionSessionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MessageRead>>> {
  const rb = new RequestBuilder(rootUrl, getMessagesApiV1MessageSessionSessionIdGet.PATH, 'get');
  if (params) {
    rb.path('session_id', params.session_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MessageRead>>;
    })
  );
}

getMessagesApiV1MessageSessionSessionIdGet.PATH = '/api/v1/message/session/{session_id}';
